import React from "react";
import {
  Placeholder,
  VisitorIdentification,
} from "@sitecore-jss/sitecore-jss-react";

import Modal from "_components/Modal";
import DigitalDataProvider from "_containers/DigitalDataContext";
import MenuProvider from "_containers/MenuContext";
import ModalProvider from "_containers/ModalContext";
import TimezoneProvider from "_containers/TimezoneContext";
import CountryProvider from "_containers/CountryContext";
import { Language } from "_types";

import { Grid, SpaLoader } from "_utils/components";

import { 
  CorpAllPagesStructuredData
} from '_utils/components/StructuredDataCorp'

import { INVISIBLE_CLASS } from "_utils/helpers/render";

import { CourseStructureData } from "./courseStructure";
import { TopicCategoryStructureData } from "./topicCategoryStructure";

import {
  ArticleContainer,
  ArticleFooterPlaceholder,
  IntroContentPlaceholder,
  MainContainer,
  MainContentPlaceholder,
  OutroContentPlaceholder,
  SidebarContainer,
  SingleColumnContainer,
} from "./StyledLayout";

/*
  DEFAULT APP LAYOUT
*/

const DefaultLayout: React.FC<any> = (props: any) => {
  const { context, loading, route } = props;
  const languageType: Language = route?.fields?.languageType?.value || null;

  return (
    <>
      <MenuProvider>
        <ModalProvider>
          <DigitalDataProvider>
            <TimezoneProvider>
              <CountryProvider>
                <Placeholder name="jss-header" rendering={route} />
                <MainContainer
                  className="intheblack-sidebar"
                  id="main-content"
                  lang={languageType}
                  name="jss-main"
                  rendering={route}
                  role="main"
                >
                  <SpaLoader />

                  {/* prevents flash reverted content when route change and personalisation applied */}
                  <div className={loading && INVISIBLE_CLASS}>
                    <Placeholder
                      name="jss-content-intro"
                      rendering={route}
                      render={(components) => (
                        <IntroContentPlaceholder>
                          {components}
                        </IntroContentPlaceholder>
                      )}
                    />
                    <Grid.Container>
                      <Grid.Row config={{ gutters: ["left", "right"] }}>
                      </Grid.Row>
                      <Grid.Row config={{ gutters: ["left", "right"] }}>
                        {/* Main content */}
                        <ArticleContainer
                          className="jss-content-main ph"
                          config={{ col: { xs: 12, md: 8 } }}
                        >
                          <MainContentPlaceholder
                            name="jss-content-main"
                            rendering={route}
                          />
                        </ArticleContainer>
                        {/* Sidebar content */}
                        <SidebarContainer
                          className="jss-content-sidebar ph"
                          config={{ col: { xs: 12, md: 4 } }}
                          rendering={route}
                        >
                          <Placeholder
                            name="jss-content-sidebar"
                            rendering={route}
                          />
                        </SidebarContainer>
                      </Grid.Row>
                    </Grid.Container>
                    <Placeholder
                      name="jss-content-outro"
                      rendering={route}
                      render={(components) => (
                        <OutroContentPlaceholder>
                          {components}
                        </OutroContentPlaceholder>
                      )}
                    />
                  </div>
                </MainContainer>
                <Placeholder name="jss-footer" rendering={route} />
                <Modal />
                {/* Google structured data */}
                <CorpAllPagesStructuredData context={context} />
                <CourseStructureData context={context} rendering={route} />
                <TopicCategoryStructureData context={context} rendering={route} />
              </CountryProvider>
            </TimezoneProvider>
          </DigitalDataProvider>
        </ModalProvider>
      </MenuProvider>
      <VisitorIdentification />
    </>
  );
};

export default DefaultLayout;
